import React from 'react'
import styled from 'styled-components'
import { Typography } from 'common/typography'

const TopicStyled = styled.article`
  h2 {
    margin-block-start: 16px;
    font: var(--headline6);
    margin-block-end: 8px;
  }
`

function Topic({ children, id, title }) {
  return (
    <TopicStyled id={id}>
      <Typography as="h2" font="headline6">{title}</Typography>
      {children}
    </TopicStyled>
  )
}

export default Topic
